import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div>
      {/* Hero */}
      <section className="max-w-5xl mx-auto px-6 pt-20 pb-14 text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 border border-primary/30 px-3 py-1 text-xs font-bold text-primarySoft tracking-wider uppercase mb-6">
          Yakında · Google Play
        </div>
        <h1 className="text-5xl sm:text-6xl font-extrabold tracking-tight leading-[1.05] mb-6">
          Türkçe kelime zinciri
          <br />
          <span className="bg-gradient-to-br from-gold to-warning bg-clip-text text-transparent">
            düellosu
          </span>
        </h1>
        <p className="text-lg text-textSecondary max-w-2xl mx-auto mb-10">
          Rakibinin kelimesinin son harfinden başla. 10 saniyede yeni bir
          kelime bul. İlk 3 puan kazanır.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#"
            aria-disabled
            className="btn-primary cursor-not-allowed opacity-80"
            title="Yakında"
          >
            📱 Google Play · Yakında
          </a>
          <Link to="/support" className="btn-outline">
            Bize yaz
          </Link>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-5xl mx-auto px-6 py-14">
        <div className="grid sm:grid-cols-3 gap-4">
          <FeatureCard
            icon="⚡"
            title="Anında eşleşme"
            body="Rastgele rakip ya da arkadaş odası — 6 haneli kodla bir tıkta."
          />
          <FeatureCard
            icon="💎"
            title="Elmas ekonomisi"
            body="Her galibiyet +10 elmas, her maç +2. Jokerler için biriktir."
          />
          <FeatureCard
            icon="🏆"
            title="Liderlik"
            body="Haftalık top 100 tablosu, galibiyet serisi, seri madalyaları."
          />
        </div>
      </section>

      {/* Legal promise */}
      <section className="max-w-3xl mx-auto px-6 py-14 text-center">
        <h2 className="text-2xl font-extrabold mb-3">Şeffaf ve güvenli</h2>
        <p className="text-textSecondary mb-6">
          Verilerinin nasıl işlendiğini kelime kelime açıkladık. Aklına takılan
          olursa bir e-posta yeter.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/terms" className="btn-outline">
            Kullanım Koşulları
          </Link>
          <Link to="/privacy" className="btn-outline">
            Gizlilik Politikası
          </Link>
          <Link to="/support" className="btn-outline">
            İletişim
          </Link>
        </div>
      </section>
    </div>
  );
}

function FeatureCard({
  icon,
  title,
  body,
}: {
  icon: string;
  title: string;
  body: string;
}) {
  return (
    <div className="card p-6">
      <div className="text-3xl mb-3">{icon}</div>
      <div className="font-extrabold mb-1">{title}</div>
      <div className="text-sm text-textSecondary leading-relaxed">{body}</div>
    </div>
  );
}
